import NavBar from "./components/navBar/navBar";
import Home from "./components/home/home";

export default function App() {
  return (
    <div className="app">
      <NavBar />
      <Home />
    </div>
  );
}
